var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('ion-icon',{staticClass:"icon-error-round",attrs:{"name":"alert"}}),_c('h2',[_vm._v("Page Not Found")]),_c('p',[_vm._v("The page you are looking for seems like it might not exist, or your session has expired.")]),_c('p',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Back to home page")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }